/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import ClaimTabs from './claimTabs';
import ClaimIdentification from './claimIdentification';
import ClaimDates from './claimDates';
import ClaimFinancial from './claimFinancial';
import ClaimOthers from './claimOthers';
import { getClaimDetails, setClaimDetailsId } from '../store/actions';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import {
  closeTab,
  handleScrollToEvent,
  redirectURLLink,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  GetAndDispatchClaimByID,
  navigateToProvider,
  setNumberOfUnitSelectBy,
  setEditedRows,
  setSelectedClaimIndex,
  setSelectedClaimModeNu,
} from '../../../Maintain/NumberOfUnits/store/action';
import { getProviderIdTypeDetails } from '../../Provider/store/action';
import ErrorPopup from '../../NDC/component/ErrorPopup';
import * as ErrorMessages from '../../../../SharedModules/Errors/constantMessageData';
import { naviagteToNDCDetailsPageAction } from '../../NDC/store/action';
import { SelectedClaimModeDataNu } from '../../../Maintain/NumberOfUnits/utils/constant';
import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import {
  dispatchPageCountwithDetails,
  dispatchSetClaimAuditSelectTabData,
  getClaimAuditDetails,
} from '../../../Research/ClaimAudits/store/actions';
import { getExistingCommentLinkIds } from '../../../../SharedModules/utilities/commonAPI';
import { checkActionAccessByRole } from '../../../../SharedModules/utilities/utilities';
//import { setSelectedClaimModeNu } from '../../../Maintain/NumberOfUnits/store/action';

const ActionDropdown = ({ data }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const selectedClaim = useSelector(
    (state) => state.sharedState.claim.selectedClaim
  );

  const searchClaimAuditSelectData = useSelector(
    (state) => state?.sharedState?.ClaimAuditReducer?.claimAuditSelectScreenData
  );

  const { claimAuditDetails, pageCountwithDetails } = useSelector(
    (state) => state?.sharedState?.ClaimAuditReducer
  );
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const [error, setError] = useState(null);

  const navigateToSelectedClaimScreen = () => {
    dispatch(setSelectedClaimModeNu(SelectedClaimModeDataNu[0]?.value));
    redirectURLLink('/units-selected-claim', 'Units Selected Claim', history, dispatch);
    dispatch(setSelectedClaimIndex(1));

    history.push({
      pathname: '/units-selected-claim',
    });
  };

  const navigateToPage = (pathName, value) => {
    let updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) == null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    if (updateTabs.findIndex((item) => item.navTo === pathName) === -1) {
      updateTabs.push({
        navTo: pathName,
        value: value,
        from: 'claim',
      });
    } else {
      updateTabs = updateTabs.map((item) => {
        if (item.navTo === pathName) {
          return {
            ...item,
            from: 'claim',
          };
        }
        return item;
      });
    }
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));

    history.push({
      pathname: pathName,
    });
  };

  const navigateToNDCPage = () => {
    redirectURLLink('/ndc-details', 'NDC Details', history, dispatch);
  };

  const gotoModifyUnits = () => {
    dispatch(setNumberOfUnitSelectBy('claimId'));
    dispatch(
      GetAndDispatchClaimByID(
        {
          claimId: data?.claimIdVO?.claimId,
          userID: logInUser,
           drugSeqNum: data?.claimIdVO?.drugSeqNum, 
          filterByDrugSeqNum: true
        },
        () => {
          navigateToSelectedClaimScreen();
        },
        true,
        true
      )
    );
    dispatch(setEditedRows([]));
  };
  React.useEffect(() => {
    handleScrollToEvent();
  }, []);
  const gotoProvider = () => {
    const payload = {
      providerId: data.providerId,
      providerIdTypeCd: data.providerIdTypeCd ?? data.providerIdType,
    };
    dispatch(getProviderIdTypeDetails());
    dispatch(
      navigateToProvider(payload, () => {
        navigateToPage('/providerDetails', 'Provider Details');
      })
    );
  };

  const gotoNDC = () => {
    let drugName = null;
    let ndc = null;
    if (
      Array.isArray(selectedClaim[0]?.claimVOList) &&
      selectedClaim[0]?.claimVOList[0]?.drugVO
    ) {
      drugName = selectedClaim[0]?.claimVOList[0]?.drugVO?.drugName;
      ndc = selectedClaim[0]?.claimVOList[0]?.drugVO?.ndc;
    } else if (selectedClaim[0]?.drugName) {
      drugName = selectedClaim[0]?.drugName;
      ndc = selectedClaim[0]?.ndc;
    }
    // const ndc = `${labelerCode}-${productCode}-${packageSize}`;
    if (selectedClaim?.length > 0) {
      dispatch(
        naviagteToNDCDetailsPageAction({
          succesFunc: () => {
            navigateToNDCPage();
          },
          ndcDetailsTableData: [
            {
              ndc,
              drugName,
            },
          ],
        })
      );
    }
  };

  const gotClaimAudits = async () => {
    if (data?.otherInfo?.claimAuditExist) {
      const paidDateRangeFrom = data.quartersVO.paidQtr;
      const paidDateRangeTo = data.quartersVO.paidQtr;
      const { rebateProgramCd } = data.otherInfo;
      const drugSeqNum = selectedClaim?.[0]?.drugSeqNum;
      dispatch(
        dispatchSetClaimAuditSelectTabData({
          ...searchClaimAuditSelectData,
          searchData: {
            paidDateRangeFrom,
            paidDateRangeTo,
            rebateProgramCd,
            reversed: 0,
            clearAudit: 0,
            auditType: 'ALL',
            speAuditType: '',
            amountAudit: 0,
            unitConversionAudit: 0,
            otherAudit: 0,
          },
        })
      );
      dispatch(
        dispatchPageCountwithDetails({
          ...pageCountwithDetails,
          inputList: {
            ...pageCountwithDetails.inputList,
            drugSeqNum: selectedClaim?.[0]?.drugSeqNum,
          },
          pageCount: 1,
        })
      );
      dispatch(
        getClaimAuditDetails({
          adtFrom: paidDateRangeFrom,
          adtTo: paidDateRangeTo,
          programcd: rebateProgramCd,
          claimReversalInd: 0,
          auditClearedInd: 0,
          drugseqnum: [selectedClaim?.[0]?.drugSeqNum],
          claimaudittype: 'ALL',
          claimspctype: '',
          claimgrptypeUA: null,
          claimgrptypeUCA: null,
          claimgrptypeOA: null,
          lastUpdateUserId: logInUser,
        })
      );
      redirectURLLink(
        '/ClaimAuditViewDetails',
        'Claim Audit View  Details',
        history,
        dispatch
      );
    } else {
      setError(ErrorMessages.CLAIM_AUDITS);
    }
  };

  const gotoPreviousClaim = () => {
    if (data?.financialVO?.prevClaimId) {
      dispatch(
        setClaimDetailsId({
          claimId: data.financialVO.prevClaimId,
          claimLineNum: data.financialVO.prevClaimLineNum,
        })
      );
      navigateToPage(
        `/claimDetails/${data.financialVO.prevClaimId}`,
        `Claim Details [${data.financialVO.prevClaimId}]`
      );
    } else {
      setError(ErrorMessages.PREVIOUS_CLAIM);
    }
  };

  const gotoReplacementClaim = () => {
    if (data?.financialVO?.replacingClaimId) {
      dispatch(
        setClaimDetailsId({
          claimId: data.financialVO.replacingClaimId,
          claimLineNum: data.financialVO.replacingClaimLineNum,
        })
      );
      navigateToPage(
        `/claimDetails/${data.financialVO.replacingClaimId}`,
        `Claim Details [${data.financialVO.replacingClaimId}]`
      );
    } else {
      setError(ErrorMessages.REPLACE_CLAIM);
    }
  };

  const gotoReversingClaim = () => {
    if (data.financialVO.reversingClaimId) {
      dispatch(
        setClaimDetailsId({
          claimId: data.financialVO.reversingClaimId,
          claimLineNum: data.financialVO.reversingClaimLineNum,
        })
      );
      navigateToPage(
        `/claimDetails/${data.financialVO.reversingClaimId}`,
        `Claim Details [${data.financialVO.reversingClaimId}]`
      );
    } else {
      setError(ErrorMessages.REVERSING_CLAIM);
    }
  };

  return data ? (
    <React.Fragment>
      <Dropdown className="icon-dropdown-container">
        <Dropdown.Toggle
          variant="primary"
          className="icon-dropdown py-0 ml-0"
          aria-label="Action"
        >
          <SVGComponent iconName="Export-icon" />
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item onClick={gotoModifyUnits}>
            Go to Modify Units
          </Dropdown.Item>
          <Dropdown.Item onClick={gotoProvider}>Go to Provider</Dropdown.Item>
          <Dropdown.Item onClick={gotoNDC}>Go to NDC</Dropdown.Item>
          <Dropdown.Item onClick={gotClaimAudits}>
            Go to Claim Audits
          </Dropdown.Item>
          <Dropdown.Item onClick={gotoPreviousClaim}>
            Go to Previous Claim
          </Dropdown.Item>
          <Dropdown.Item onClick={gotoReplacementClaim}>
            Go to Replacement Claim
          </Dropdown.Item>
          <Dropdown.Item onClick={gotoReversingClaim}>
            Go to Reversing Claim
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
      <ErrorPopup
        modalTitle="Selected Claim"
        errorPopupMessage={error}
        onClose={() => setError(null)}
      />
    </React.Fragment>
  ) : (
    <></>
  );
};

export default function ClaimDetails() {
  const dispatch = useDispatch();
  const history = useHistory();

  const [fullScreenView, setFullScreenView] = useState(false);
  const [tabValue, setTabValue] = useState('one');
  const [ccCommentsExist, setCcCommentsExist] = useState(0);
  const activeClaimCode = window.location.pathname.split('/')[2];
  const [hasAccess, setHasAccess] = React.useState(
    checkActionAccessByRole(process.env.REACT_APP_HIDE_ACCESS_ROLES, kcRoles)
  );
  const find_claimDetails = useSelector((state) =>
    state?.sharedState?.ClaimDetailsReducer?.claimDetails?.find((obj) => {
      return obj[activeClaimCode];
    })
  );
  const claimDetails = find_claimDetails?.[activeClaimCode]?.data;
  const claimDetailsId = useSelector(
    (state) => state?.sharedState?.ClaimDetailsReducer?.claimDetailsId
  );
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  React.useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setHasAccess(
        checkActionAccessByRole(
          process.env.REACT_APP_HIDE_ACCESS_ROLES,
          kcRoles
        )
      );
    }
  }, []);

  useEffect(() => {
    if (claimDetails?.corrLinkId) {
      getExistingCommentLinkIds([claimDetails.corrLinkId])
        .then((res) => {
          setCcCommentsExist(res?.includes(claimDetails.corrLinkId) ? 1 : 0);
        })
        .catch((err) => {});
    } else {
      setCcCommentsExist(0);
    }
  }, [claimDetails]);

  useEffect(() => {
    if (claimDetailsId) {
      dispatch(getClaimDetails(claimDetailsId));
    }
  }, [claimDetailsId]);

  const [showComments, setShowComments] = useState(false);
  return (
    <div data-testid="create-manufacurer">
      <div className="tBillPanel custom-check">
        <div className="panel tBillPanel-space pb-0">
          <Spinner load={spinnerLoader} />
          <CustomSeparator
            parent1="Display"
            parent2={`ClaimDetail [${activeClaimCode}]`}
          />
          {!fullScreenView && (
            <fieldset className="custom-fieldset">
              <form autoComplete="off">
                <div className="form-wrapper form-wrapper-col-4">
                  <div className="mui-custom-form input-md">
                    <TextField
                      id="claim_number"
                      label="Claim Number"
                      data-testid="Claim-Number"
                      fullWidth
                      placeholder=""
                      disabled
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={claimDetails?.claimIdVO?.claimId || ''}
                    />
                  </div>
                  <div className="mui-custom-form input-md">
                    <TextField
                      id="claim_version"
                      label="Claim Version"
                      data-testid="Claim-Version"
                      fullWidth
                      placeholder=""
                      disabled
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={claimDetails?.claimVersionCd || ''}
                    />
                  </div>
                  <div className="mui-custom-form input-md">
                    <TextField
                      id="claim_line_number"
                      label="Claim Line Number"
                      data-testid="Claim-Line-Number"
                      fullWidth
                      placeholder=""
                      disabled
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={claimDetails?.claimIdVO?.claimLineNum || ''}
                    />
                  </div>
                  <div className="mui-custom-form input-md">
                    <TextField
                      id="claim_category"
                      label="Claim Category"
                      data-testid="Claim-Category"
                      fullWidth
                      placeholder=""
                      disabled
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={claimDetails?.claimCategoryCd || ''}
                    />
                  </div>
                </div>
                <div className="form-wrapper form-wrapper-col-4">
                  <div className="mui-custom-form input-md">
                    <TextField
                      id="provider_id_type"
                      label="Provider ID Type"
                      data-testid="Claim-Line-Number"
                      fullWidth
                      required
                      placeholder=""
                      disabled
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={claimDetails?.providerIdType || ''}
                    />
                  </div>
                  <div className="mui-custom-form input-md">
                    <TextField
                      id="provider_id"
                      label="Provider ID"
                      data-testid="Claim-Line-Number"
                      fullWidth
                      placeholder=""
                      disabled
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={claimDetails?.providerId || ''}
                    />
                  </div>
                  {hasAccess && (
                    <div className="mui-custom-form input-md">
                      <div className="comment-sec mt-26">
                        Comments {'  '}
                        {parseInt(ccCommentsExist, [0, 1]) === 1 ? (
                          <img
                            role="button"
                            onClick={() => {
                              setShowComments(true);
                            }}
                            alt=" comment "
                            tabIndex={'0'}
                            onKeyDown={(e) => {
                              // Handle Enter and Space key events
                              if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault(); // Prevents the default space scrolling behavior
                                setShowComments(true);
                              }
                            }}
                            src={CommentVisibleIcon}
                          />
                        ) : (
                          <img
                            role="button"
                            onClick={() => {
                              setShowComments(true);
                            }}
                            alt="comment"
                            tabIndex={'0'}
                            onKeyDown={(e) => {
                              // Handle Enter and Space key events
                              if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault(); // Prevents the default space scrolling behavior
                                setShowComments(true);
                              }
                            }}
                            src={CommentIcon}
                          />
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </form>
            </fieldset>
          )}
          <div className="tabs-wrapper d-flex justify-content-between col-12">
            <ClaimTabs
              data-testid="claim-tabs"
              handleChangeTabValue={(event, newValue) => {
                setTabValue(newValue);
              }}
              tabValue={tabValue}
            />
            <div className="d-flex align-items-center th-icon-group">
              <ActionDropdown data={claimDetails} />
              <OverlayTrigger
                placement="bottom"
                overlay={
                  <Tooltip id="fullScreen-tooltip">
                    {fullScreenView ? 'Minimize Screen' : 'Full Screen'}{' '}
                  </Tooltip>
                }
              >
                <div
                  className={
                    fullScreenView
                      ? 'th-icon ic-fulScreen-exit'
                      : 'th-icon ic-fulScreen'
                  }
                  role="button"
                  data-testid="setFullScreenView"
                  onClick={() => {
                    setFullScreenView(!fullScreenView);
                  }}
                >
                  <span className="ic-title">
                    {' '}
                    {fullScreenView ? 'Minimize Screen' : 'Full Screen'}{' '}
                  </span>
                </div>
              </OverlayTrigger>
            </div>
            <div className="clearfix" />
          </div>
          <div className="tabs-body mt-4">
            {tabValue === 'one' && (
              <ClaimIdentification claimDetails={claimDetails} />
            )}
            {tabValue === 'two' && (
              <ClaimFinancial claimDetails={claimDetails} />
            )}
            {tabValue === 'three' && <ClaimDates claimDetails={claimDetails} />}
            {tabValue === 'four' && <ClaimOthers claimDetails={claimDetails} />}
          </div>
        </div>
      </div>
      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={setShowComments}
          linkTableName="CLAIM"
          corrLinkId={claimDetails && claimDetails.corrLinkId}
          rowGridPrimaryKey={
            claimDetails && claimDetails.length > 0 ? claimDetailsId : 0
          }
        />
      ) : null}
    </div>
  );
}
